const formatPlugin = () => {
  const data = (): Date => {
    const date = new Date()
    date.setHours(date.getHours() + 3)
    return date
  }

  data.toFormatBR = (dataV: Date | string | number) => {
    return new Date(dataV || data()).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  const number = (value: any) => {
    try {
      return parseFloat(value)
    } catch {
      return 0
    }
  }

  number.toFormatMoney = (value: number | string): string => {
    if (!value) {
      return '0,00'
    }

    if (typeof value == 'string') {
      value = parseFloat(value)
    }

    // Arredondar o valor para 2 casas decimais
    let valorStr = value.toFixed(2) // Vai arredondar para 2 casas decimais

    // Remover espaços e caracteres não numéricos, mantendo apenas números e vírgula
    valorStr = valorStr.replace(/\s+/g, '').replace(/[^\d.,]/g, '')

    // Separar a parte inteira e decimal usando a vírgula como separador
    let [inteiro, decimal] = valorStr.split('.')

    // Adicionar separadores de milhar na parte inteira, se necessário
    inteiro = inteiro.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    // Se o valor for uma parte decimal vazia, definir como '00'
    decimal = decimal || '00'

    // Retornar o valor formatado com vírgula entre parte inteira e decimal
    return `${inteiro},${decimal}`
  }

  const string = (value: any): string => {
    return value.toString()
  }

  string.toFormatPhoneNumber = (numero: string | number) => {
    numero = string(numero)
    const numeroLimpo = numero.replace(/\D/g, '')

    return `(${numeroLimpo.slice(0, 2)}) ${numeroLimpo.slice(2, 7)}-${numeroLimpo.slice(7)}`
  }

  return {
    data,
    number,
    string,
  }
}

export default {
  install: (app: any) => {
    app.config.globalProperties.$format = formatPlugin
  },
}

export type FormatPlugin = typeof formatPlugin
